/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spotify_Apple_Music_LinkInputs */

const en_spotify_apple_music_link = /** @type {(inputs: Spotify_Apple_Music_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spotify / Apple Music Link`)
};

const es_spotify_apple_music_link = /** @type {(inputs: Spotify_Apple_Music_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlace de Spotify / Apple Music`)
};

const fr_spotify_apple_music_link = /** @type {(inputs: Spotify_Apple_Music_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien Spotify / Apple Music`)
};

const de_spotify_apple_music_link = /** @type {(inputs: Spotify_Apple_Music_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spotify / Apple Music Link`)
};

const ja_spotify_apple_music_link = /** @type {(inputs: Spotify_Apple_Music_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spotify / Apple Music リンク`)
};

const zh_spotify_apple_music_link = /** @type {(inputs: Spotify_Apple_Music_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spotify / Apple Music 链接`)
};

const ar_spotify_apple_music_link = /** @type {(inputs: Spotify_Apple_Music_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رابط سبوتيفاي / أبل ميوزيك`)
};

const id_spotify_apple_music_link = /** @type {(inputs: Spotify_Apple_Music_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan Spotify / Apple Music`)
};

const it_spotify_apple_music_link = /** @type {(inputs: Spotify_Apple_Music_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Spotify / Apple Music`)
};

const ru_spotify_apple_music_link = /** @type {(inputs: Spotify_Apple_Music_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ссылка Spotify / Apple Music`)
};

const pt_spotify_apple_music_link = /** @type {(inputs: Spotify_Apple_Music_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link do Spotify / Apple Music`)
};

const ko_spotify_apple_music_link = /** @type {(inputs: Spotify_Apple_Music_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spotify / Apple Music 링크`)
};

/**
* | output |
* | --- |
* | "Spotify / Apple Music Link" |
*
* @param {Spotify_Apple_Music_LinkInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const spotify_apple_music_link = /** @type {((inputs?: Spotify_Apple_Music_LinkInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spotify_Apple_Music_LinkInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_spotify_apple_music_link(inputs)
	if (locale === "es") return es_spotify_apple_music_link(inputs)
	if (locale === "fr") return fr_spotify_apple_music_link(inputs)
	if (locale === "de") return de_spotify_apple_music_link(inputs)
	if (locale === "ja") return ja_spotify_apple_music_link(inputs)
	if (locale === "zh") return zh_spotify_apple_music_link(inputs)
	if (locale === "ar") return ar_spotify_apple_music_link(inputs)
	if (locale === "id") return id_spotify_apple_music_link(inputs)
	if (locale === "it") return it_spotify_apple_music_link(inputs)
	if (locale === "ru") return ru_spotify_apple_music_link(inputs)
	if (locale === "pt") return pt_spotify_apple_music_link(inputs)
	return ko_spotify_apple_music_link(inputs)
});